import { Children } from "react";
import { useLingui } from "@lingui/react/macro";
import styles from "./SplitPane.module.scss";
import useSplitPaneResize, {
  type InitialLeadingPanelSize,
} from "./useSplitPaneResize";

export const SplitPane = ({
  children,
  initialLeadingPanelSize = "66%",
  minPanelSize = 300,
  panelSizeLocalStorageKey,
}: {
  children: React.ReactNode;
  initialLeadingPanelSize?: InitialLeadingPanelSize;
  minPanelSize?: number;
  panelSizeLocalStorageKey?: string;
}) => {
  const { t } = useLingui();
  const [leading, trailing] = Children.toArray(children);
  const { containerRef, handleRef, ariaValueNow, ariaValueMin, ariaValueMax } =
    useSplitPaneResize({
      initialLeadingPanelSize,
      minPanelSize,
      panelSizeLocalStorageKey,
    });

  return (
    <div ref={containerRef} className={styles.splitPane}>
      {leading}
      {/* oxlint-disable jsx-a11y/prefer-tag-over-role -- This is a focusable window-splitter widget, not a static thematic break. */}
      <div
        ref={handleRef}
        role="separator"
        aria-orientation="vertical"
        aria-label={t`Justera bredd`}
        aria-valuenow={ariaValueNow}
        aria-valuemin={ariaValueMin}
        aria-valuemax={ariaValueMax}
        title={t`Dra för att justera bredd`}
        className={styles.handle}
      />
      {/* oxlint-enable jsx-a11y/prefer-tag-over-role */}
      {trailing}
    </div>
  );
};
